export const FORMINPUTSALL_REQUEST = "FORMINPUTSALL_REQUEST";
export const FORMINPUTSALL_SUCCESS = "FORMINPUTSALL_SUCCESS";
export const FORMINPUTSALL_FAIL = "FORMINPUTSALL_FAIL";